import { render, staticRenderFns } from "./NewAccountSettingRate.vue?vue&type=template&id=43135533&"
import script from "./NewAccountSettingRate.vue?vue&type=script&lang=js&"
export * from "./NewAccountSettingRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports